import React from 'react';

export function Alert({ children, tone = 'info', className = '' }) {
  return (
    <div className={`ds-alert ds-alert--${tone} ${className}`.trim()} role="alert">
      {children}
    </div>
  );
}

export default Alert;
